import { ReactComponent as ArrowRight } from "../assets/arrow-right.svg";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="ml-[10%] flex items-center">
      <div>
        <div className="text-primary-main truncate text-sm font-semibold text-green md:mb-3">404 ERROR</div>
        <div className="text-custom-color mb-2 text-4xl font-bold md:mb-2 md:mr-4">Page not found</div>
        <div className="text-sm font-bold leading-tight text-greyScale100 md:mb-5">
          Sorry, we couldn't find the page you're looking for.
        </div>
        <Link to="/">
          <button className="flex items-center gap-2 rounded bg-green px-4 py-2 text-white">
            Go to Opslink homepage <ArrowRight />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Error;
